import React, { useState, useEffect, useCallback } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Card, Container, Row, Button, Col } from 'react-bootstrap';

import Aux from '../../hoc/Aux/Aux';
import AliCard from '../../components/UI/Card/Card';
import BuildControls from '../../components/Burger/BuildControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary';
import Spinner from '../../components/UI/Spinner/Spinner';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import axios from '../../axios-orders';
import cardCss from '../../components/UI/Card/Card.css';

const burgerBuilder = props => {
  return (
    <Aux>
      <div className='panel panel-default align-items-center p-3 my-3' style={{'width':'100%', 'paddingTop':'0px', height:'100%', 'overflow':'scroll'}}>
            <div className='align-items-center p-3 my-3 rounded shadow panel-heading' style={{'boxShadow':'0 4px 8px 0 #042a4a', 'transition': '0.3s','color':"black","textAlign":"left", 'width':'98%', "align":"left"}}>
   
        <div className={cardCss.mainDiv}>
         <AliCard></AliCard>
        </div>
      </div>
      </div>
    </Aux>
  );
};

export default withErrorHandler(burgerBuilder, axios);



// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePage.js